import { mapToNamedProperty, NamedProperty } from "sprint-common-web";

import { SystemPlatformSpecificationResponse } from "../../../common/api/orders-api/airline/GetSystemPlatformDetailsResponse";
import { EncodeSpecificationContentType } from "../../../common/types/EncodeSpecificationContentType";

export interface SystemPlatformSpecification {
    encodeSpecificationContentType: EncodeSpecificationContentType;
    defaultEncodeSpecification: NamedProperty | undefined;
    encodeSpecifications: NamedProperty[];
}

export const mapToSystemPlatformSpecification = (
    specification: SystemPlatformSpecificationResponse
): SystemPlatformSpecification => {
    return {
        encodeSpecificationContentType: specification.encodeSpecificationContentType,
        defaultEncodeSpecification: specification.defaultEncodeSpecification
            ? mapToNamedProperty(specification.defaultEncodeSpecification)
            : undefined,
        encodeSpecifications: specification.encodeSpecifications.map((spec) => mapToNamedProperty(spec))
    };
};
